import { MenuItem, TextField } from '@material-ui/core';
import React, { useEffect, useState } from 'react';

import { getUnrulyDSPs, IUnrulyDSP } from '~/src/dash/api/deal-providers/unruly';

interface IUnrulyDSPSelectProps {
  name: string;
  label: string;
  onChange: (elem: React.ChangeEvent) => void;
  publisherID: string;
  value: number;
  error: boolean;
  helperText: string;
}

export const UnrulyDSPTargetingSelect = function ({
  onChange,
  name,
  label,
  value,
  publisherID,
  error,
  helperText,
}: IUnrulyDSPSelectProps) {
  const [unrulyDSPs, seIUnrulyDSPs] = useState<IUnrulyDSP[]>([]);

  async function loaIUnrulyDSPs() {
    try {
      const currenIUnrulyDSPs = await getUnrulyDSPs(publisherID);
      seIUnrulyDSPs(currenIUnrulyDSPs);
    } catch (e) {
      seIUnrulyDSPs([]);
    }
  }

  useEffect(() => {
    loaIUnrulyDSPs();
  }, [publisherID]);

  return (
    <TextField
      select
      fullWidth
      required
      name={name}
      type='number'
      label={label}
      onChange={onChange}
      value={value}
      error={error}
      helperText={helperText}
    >
      {unrulyDSPs.map((unrulyDSP: IUnrulyDSP) => {
        return (
          <MenuItem key={unrulyDSP.id} value={unrulyDSP.id}>
            {unrulyDSP.nameDisplay}
          </MenuItem>
        );
      })}
    </TextField>
  );
};
